import { integrationsRoutes } from 'constants/navigation';

export const integrationsSidebarConfig = [
  {
    title: 'Coderbyte',
    path: integrationsRoutes.coderbyte.path,
  },
  {
    title: 'Kombo',
    path: integrationsRoutes.kombo.path,
  },
];
